<template>
    <v-card width="100%" elevation="0" color="transparent" :to="`/shop/products/${product._id}`" class="overflow-visible">
        <v-responsive width="100%" aspect-ratio="1">
            <v-sheet width="100%" height="100%" class="d-flex align-center">
                <v-img src="/images/main/icon-crown.png" width="35" height="55" contain class="crown" />
                <v-img :src="product.thumb" contain :aspect-ratio="1 / 1"></v-img>
            </v-sheet>
        </v-responsive>

        <div class="text-center mt-14px px-10px">
            <div>
                <div class="font-size-16 font-size-md-18 font-weight-medium text-truncate">{{ product.name }}</div>
            </div>

            <div class="mt-4px">
                <v-row no-gutters align="center" justify="center" class="font-size-14 grey--text text--darken-2">
                    <v-col cols="auto">
                        <span>{{ product.writer }}</span>
                    </v-col>
                    <v-col cols="auto" class="d-flex">
                        <v-divider v-if="product.writer && product.publisher" vertical class="mx-8px" style="max-height:10px; min-height:10px;" />
                    </v-col>
                    <v-col cols="auto">
                        <span>{{ product.publisher }}</span>
                    </v-col>
                </v-row>
            </div>

            <div class="mt-4px">
                <div class="font-size-16">
                    <b class="primary--text">{{ product.salePrice.format() }}</b
                    >원
                </div>
            </div>
        </div>
    </v-card>

    <!-- <v-card outlined width="100%" elevation="0" color="transparent" :to="`/shop/products/${product._id}`">
        <div>
            <v-responsive width="100%" aspect-ratio="1">
                <v-sheet width="100%" height="100%" outlined class="d-flex align-center">
                    <v-img :src="product.thumb" max-width="500" height="172" contain aspect-ratio="1"></v-img>
                </v-sheet>
            </v-responsive>
            <v-responsive class="mt-4 text-center">
                <div class="tit tit--xs text-truncate" >{{ product.name }}</div>
                <v-layout class="mt-1 caption text-truncate" justify-center>
                    <span>{{ product.writer }}</span>
                    <v-divider v-if="product.writer && product.publisher" vertical class="mx-2 my-1"/>
                    <span>{{ product.publisher }}</span>
                </v-layout>
                <div class="font-size-16 mt-1"><b class="primary--text">{{ product.salePrice.format() }}</b> 원</div>
            </v-responsive>
            <v-img src="/images/main/icon-crown.png" width="35" height="55" contain class="crown"/>
        </div>
    </v-card> -->
</template>
<script>
export default {
    props: {
        product: { type: Object },
    },
};
</script>

<style lang="scss" scoped>
.v-card {
    position: relative;
}
.v-card .crown {
    position: absolute;
    top: 10px;
    right: calc(100% * 2 / 3);
    z-index: 1;
}
</style>
